export const selectSessions = s => s.environmentSession;
